// V71.17 — Ön yüz hatası Sistem › Hata Kayıtları'na bildirilir. axios değil fetch: raporun kendisi düşerse
// oturum penceresi ya da yeni rapor döngüsü doğmasın. Aynı mesaj açılış başına bir kez gider, en çok 10 rapor.
import VERSION from '../version';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const SINIR = 10;
const bildirilenler = new Map(); // mesaj → kod sözü (aynı hata yine sorulursa aynı kod döner)

export function hataBildir(mesaj, ayrinti) {
  const anahtar = String(mesaj || '').trim().slice(0, 500);
  if (!anahtar) return Promise.resolve(null);
  if (bildirilenler.has(anahtar)) return bildirilenler.get(anahtar);
  if (bildirilenler.size >= SINIR) return Promise.resolve(null);
  const token = localStorage.getItem('mtu_token');
  const soz = fetch(`${API_BASE}/hata-kayitlari/bildir`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ mesaj: anahtar, ayrinti: ayrinti ? String(ayrinti).slice(0, 20000) : undefined, ekran: window.location.pathname, surum: VERSION }),
  }).then(r => (r.ok ? r.json() : null)).then(g => g?.kod || null).catch(() => null);
  bildirilenler.set(anahtar, soz);
  return soz;
}

// Bildirilmeyenler: API (axios) hatası — 5xx'i sunucu yazdı, 4xx kuralın kendisi; iptal; bayat chunk
// (lazyRetry sayfayı yeniler); tarayıcının zararsız ResizeObserver uyarısı ve kaynağı görünmeyen "Script error."
export function bildirilmeli(hata) {
  if (!hata || hata.isAxiosError || hata.sessionPaused) return false;
  if (['AbortError', 'CanceledError', 'ChunkLoadError'].includes(hata.name)) return false;
  const mesaj = String(hata.message ?? hata).trim();
  return !!mesaj && mesaj !== 'Script error.' && !mesaj.startsWith('ResizeObserver loop');
}

// Ekranı çökertmeyen hatalar (düğme işleyicisi, yakalanmamış söz) — çizim hatasını HataSiniri yakalar
export function genelHataDinleyicisiKur() {
  const yakala = (hata) => {
    if (bildirilmeli(hata)) hataBildir(`Yakalanmamış hata: ${hata.message ?? hata}`, hata.stack);
  };
  window.addEventListener('error', e => yakala(e.error ?? e.message));
  window.addEventListener('unhandledrejection', e => yakala(e.reason));
}
